import { render, staticRenderFns } from "./ItemResultModal.vue?vue&type=template&id=6fb12672&"
import script from "./ItemResultModal.vue?vue&type=script&lang=js&"
export * from "./ItemResultModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemResultModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports